import { sendPostRequest } from "./logBackendService";

const createLead = async (email, name, phone, testResult) => {
  const url = "https://webhooks.nevenkagarcia.com/webhook/b7587757-2635-4dd1-b5a3-07d0037dbb01";

  const data = {
    email: email,
    username: name,
    contact: phone,
    result: {
      resulttest_demeter: testResult.demeter,
      resulttest_hera: testResult.hera,
      resulttest_afrodite: testResult.afrodite,
      resulttest_artemis: testResult.artemis,
      resulttest_atena: testResult.atena,
      resulttest_persefone: testResult.persefone,
    },
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    console.log("Webhook enviado com sucesso:", result);
  } catch (error) {
    await sendPostRequest(data, url);
    console.error("Erro ao enviar webhook:", error);
  }
};

// Exporta a função
export { createLead };
